import { useTheme } from '@emotion/react';
import { SignalStrength } from '@icon-park/react';
import cn from 'classnames';
import { cloneElement, type MemoExoticComponent, memo, type ReactNode } from 'react';

import { SIZES } from './constants';
import * as styles from './ResourcePicture.styles';

export type ResourcePictureProps = {
  picture?: { href: string } | null;
  children?: ReactNode;
  size?: SIZES;
};

export const ResourcePictureBase = ({
  picture = null,
  children = null,
  size = SIZES.MEDIUM,
}: ResourcePictureProps) => {
  const theme = useTheme();

  const icon = <SignalStrength />;

  return (
    <div className={cn(size)} css={styles.container(picture?.href)}>
      {!picture &&
        cloneElement(icon, {
          size: 48,
          strokeWidth: 2,
          fill: [theme.colors.primary[500], theme.colors.primary[50]],
        })}

      {children}
    </div>
  );
};

ResourcePictureBase.displayName = 'ResourcePicture';

export const ResourcePicture: MemoExoticComponent<typeof ResourcePictureBase> & {
  SIZES?: typeof SIZES;
} = memo(ResourcePictureBase);

ResourcePicture.SIZES = SIZES;
